/**
 *
 */

(function($) {

    $.getJSON("https://www.kotitalolehti.fi/wp-json/wp/v2/posts?per_page=3", function(data) {
        $.each(data, function(i,post){

            var link = post.link;
            var title = post.title.rendered;
            var excerpt = post.excerpt.rendered;

            $(".kotitalolehti-posts").append(
                "<div class='post'><a href='" + link + "'  target='_blank' rel='noopener noreferrer'  class='news-title'>" + title + "</a>" + excerpt + "</div>"
            );
        });
    });


})(jQuery);

